import { Form, Formik } from "formik";
import React from "react";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";
import { UPDATE_ANNOUNCEMENT } from "../../../api/apiAnuncios";

const ModalEditAnuncio = ({ anuncio, onClose, refetch}) => {
    const validate = (values) => {
        const errors = {};

        if (!values.title) { errors.title = "El titulo es requerido"; }
        if (!values.description) { errors.description = "El contenido es requerido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await UPDATE_ANNOUNCEMENT(anuncio.id, values);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { title: anuncio.title || "", description: anuncio.description || "" }

    return(
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate} >
                {({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="title" label="Titulo" placeholder="Titulo del aviso" />
                        <InputField name="description" label="Contenido" placeholder="Contenido del aviso" type="textarea"/>
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Actualizar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                    </Form>
                )}
            </Formik>
        </div>
    )
};

export default ModalEditAnuncio;